/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs */

const en_admin_external_booking_edit_order_summary_custom_total_net_tooltip = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Net amount, exclusive of tax.`)
};

const de_admin_external_booking_edit_order_summary_custom_total_net_tooltip = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettobetrag, ohne Steuern.`)
};

const es_admin_external_booking_edit_order_summary_custom_total_net_tooltip = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe neto, sin impuestos.`)
};

const fr_admin_external_booking_edit_order_summary_custom_total_net_tooltip = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant net, hors taxes.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs) => LocalizedString} */
const it_admin_external_booking_edit_order_summary_custom_total_net_tooltip = en_admin_external_booking_edit_order_summary_custom_total_net_tooltip;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_order_summary_custom_total_net_tooltip = en_admin_external_booking_edit_order_summary_custom_total_net_tooltip;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs) => LocalizedString} */
const pl_admin_external_booking_edit_order_summary_custom_total_net_tooltip = en_admin_external_booking_edit_order_summary_custom_total_net_tooltip;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs) => LocalizedString} */
const hu_admin_external_booking_edit_order_summary_custom_total_net_tooltip = en_admin_external_booking_edit_order_summary_custom_total_net_tooltip;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs) => LocalizedString} */
const ro_admin_external_booking_edit_order_summary_custom_total_net_tooltip = en_admin_external_booking_edit_order_summary_custom_total_net_tooltip;

/**
* | output |
* | --- |
* | "Net amount, exclusive of tax." |
*
* @param {Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_custom_total_net_tooltip = /** @type {((inputs?: Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_Custom_Total_Net_TooltipInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_custom_total_net_tooltip(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_custom_total_net_tooltip(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_custom_total_net_tooltip(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_custom_total_net_tooltip(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_custom_total_net_tooltip(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_custom_total_net_tooltip(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_custom_total_net_tooltip(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_custom_total_net_tooltip(inputs)
	return ro_admin_external_booking_edit_order_summary_custom_total_net_tooltip(inputs)
});
export { admin_external_booking_edit_order_summary_custom_total_net_tooltip as "admin.external_booking_edit.order_summary.custom_total_net_tooltip" }